var styles = {"hero":"styles_hero__2i6RL relative center","hero-image":"styles_hero-image__9MYQO","heroImage":"styles_hero-image__9MYQO","title":"styles_title__3FzfQ bold absolute top-0 left-0 right-0 bottom-0","caption":"styles_caption__3O13A p2 flex items-center","curation-icon":"styles_curation-icon__1zOeg mr1","curationIcon":"styles_curation-icon__1zOeg mr1"};

export default styles;
//# sourceMappingURL=styles.css.js.map
